import React, { useState } from "react";
import ModalPortal from "../../../portal/ModalPortal";
import {
    UsersForm, FormControl, Label, Input, FormTitle, NameSurname, NameFirst, Surname, ModalAddButtonService,
    ModalDarkBackGround, ModalStyleService,
    ModalCloseButtonService, ModalStyleMobileResponsive, InputProfileForm,
    LabelProfile, DivForLabelAndInput, ModalAddButtonServices, CloseButton, ModalCloseButton
} from "../../styles/MainLayout"
import { useParams } from "react-router-dom";
import axios from "../../../axios";
import { toast } from "react-toastify";
import { CloseButtonMobile, ModalCloseButtonMobile } from "../../styles/MainLayoutResponsive";

const SubSubServiceModal = (props) => {
    const [viewportSize, setViewportSize] = useState(window.innerWidth);
    window.addEventListener("resize", () => {
        setViewportSize(window.innerWidth);
    });
    const { sid, subid } = useParams();
    //AXIOS
    const SubServiceAdd = (e) => {
        e.preventDefault();
        let body = {
            sevice_id: sid,
            sub_service_id: subid,
            name_al: e.target.name_al.value,
            name_en: e.target.name_en.value
        }
        axios
            .post(`/api/admin/sub_sub_services`, body)
            .then(data => {
                props?.handleModalClose();
                toast.success(data?.data.msg)
                props?.getSubService();
            }
            ).catch(
                err => {
                    toast.error("Error creating new service!")
                    console.log(err)
                }
            )
    }
    //AXIOS
    const [editServiceName, setEditServiceName] = useState()
    const SubServiceEdit = (e) => {
        e.preventDefault();
        let body = {
            service_id: Number(sid),
            sub_service_id: subid,
            id: props?.data?.id,
            name_al: e.target.name_al.value,
            name_en: e.target.name_en.value
        }
        console.log("body", body)
        axios.put(`/api/admin/sub_sub_services/update`, body)
            .then((data) => {
                props?.handleModalClose();
                props?.getSubService();
                console.log(data.data)
                toast.success("Edited sucessfully")
            }).catch(
                err => {

                    console.log(err)
                }
            )
    }
    console.log("PROPSAT", props)
    if (props?.isOpen) {
        if (viewportSize > 800) {
            // ----DESKTOP VIEW---- //
            return (
                <>
                    <ModalPortal>
                        <ModalDarkBackGround onClick={() => props?.handleModalClose()} />
                        <ModalStyleService>
                            <CloseButton>
                                <ModalCloseButton type={"button"} onClick={() => props.handleModalClose()}>X</ModalCloseButton>
                            </CloseButton>

                            {props?.type === "add" ?

                                <>
                                    <FormTitle className="d-flex justify-content-center mt-3">Add Subsub Service</FormTitle>
                                    <hr />
                                    <UsersForm onSubmit={SubServiceAdd}>
                                        <FormControl>
                                            <NameSurname>
                                                <NameFirst>
                                                    <DivForLabelAndInput className="forDisable">
                                                        <LabelProfile >Emri i Sherbimit Shqip</LabelProfile>
                                                        <InputProfileForm placeholder="Emri sherbimit" type="text" name="name_al" id="name_al" />
                                                    </DivForLabelAndInput>
                                                </NameFirst>
                                                <Surname>
                                                    <DivForLabelAndInput className="forDisable">
                                                        <LabelProfile> Service Name English</LabelProfile>
                                                        <InputProfileForm placeholder="Service name" type="text" name="name_en" />
                                                    </DivForLabelAndInput>
                                                </Surname>
                                            </NameSurname>
                                            <br />
                                            <div className="d-flex justify-content-end">
                                                <ModalAddButtonServices type="submit">Add</ModalAddButtonServices>
                                            </div>
                                        </FormControl>
                                    </UsersForm>
                                </>
                                :
                                props?.type === "edit" ?
                                    <>
                                        <FormTitle className="d-flex justify-content-center mt-3">Edit Sub Service</FormTitle>
                                        <hr />
                                        <UsersForm type={props?.type} onSubmit={SubServiceEdit} >
                                            <FormControl>
                                                <NameSurname>
                                                    <NameFirst>
                                                        <DivForLabelAndInput className="forDisable">
                                                            <LabelProfile >Emri i Sherbimit Shqip</LabelProfile>
                                                            <InputProfileForm defaultValue={props?.data?.name_al} onChange={(e) => setEditServiceName(e.target.value)} placeholder="Emri sherbimit" type="text" name="name_al" />
                                                        </DivForLabelAndInput>
                                                    </NameFirst>
                                                    <Surname>
                                                        <DivForLabelAndInput className="forDisable">
                                                            <LabelProfile> Service Name English </LabelProfile>
                                                            <InputProfileForm defaultValue={props?.data?.name_en} placeholder="Service name" type="text" name="name_en" />
                                                        </DivForLabelAndInput>
                                                    </Surname>
                                                </NameSurname>
                                                <br />   
                                                <div className="d-flex justify-content-end">
                                                    <ModalAddButtonServices type="submit">Edit</ModalAddButtonServices>
                                                </div>


                                            </FormControl>
                                        </UsersForm>
                                    </>
                                    :
                                    ""
                            }

                        </ModalStyleService>
                    </ModalPortal>
                </>
            )
        }
        //   ----MOBILE VIEW----- //
        else {
            return (
                <>
                    <ModalDarkBackGround onClick={() => props.handleModalClose()} />
                    <ModalStyleMobileResponsive>
                        <CloseButtonMobile>

                            <ModalCloseButtonMobile type={"button"} onClick={() => props?.handleModalClose()}>X</ModalCloseButtonMobile>
                        </CloseButtonMobile>
                        {props?.type === "add" ?
                            <>
                                <FormTitle className="d-flex justify-content-center mt-3">Add Sub Service</FormTitle>
                                <hr />
                                <UsersForm onSubmit={SubServiceAdd}>
                                    <FormControl>
                                        <NameSurname>
                                            <NameFirst>
                                                <DivForLabelAndInput className="forDisable">
                                                    <LabelProfile >Emri i Sherbimit Shqip</LabelProfile>
                                                    <InputProfileForm placeholder="Emri sherbimit" type="text" name="name_al" id="name_al" />
                                                </DivForLabelAndInput>
                                            </NameFirst>
                                            <DivForLabelAndInput className="forDisable">
                                                <LabelProfile >Service Name English</LabelProfile>
                                                <InputProfileForm placeholder="Emri sherbimit" type="text" name="name_en" id="name_en" />
                                            </DivForLabelAndInput>
                                        </NameSurname>
                                        <br />
                                        <div className="d-flex justify-content-end mt-4 mb-2">
                                            <ModalAddButtonService type={"submit"}>Add</ModalAddButtonService>
                                        </div>
                                    </FormControl>
                                </UsersForm>
                            </>
                            :
                            props?.type === "edit" ?
                                <>
                                    <FormTitle className="d-flex justify-content-center mt-3">Edit Sub Service</FormTitle>
                                    <hr />
                                    <UsersForm onSubmit={SubServiceEdit}>
                                        <FormControl>
                                            <NameSurname>
                                                <NameFirst>
                                                    <DivForLabelAndInput className="forDisable">

                                                        <LabelProfile >Emri i Sherbimit Shqip</LabelProfile>
                                                        <InputProfileForm defaultValue={props?.data?.name_al} onChange={(e) => setEditServiceName(e.target.value)} placeholder="Emri sherbimit" type="text" name="name_al" />
                                                    </DivForLabelAndInput>
                                                    <DivForLabelAndInput className="forDisable">

                                                        <LabelProfile >Service Name English</LabelProfile>
                                                        <InputProfileForm defaultValue={props?.data?.name_en} onChange={(e) => setEditServiceName(e.target.value)} placeholder="Emri sherbimit" type="text" name="name_en" />
                                                    </DivForLabelAndInput>
                                                </NameFirst>

                                            </NameSurname>
                                            <br />
                                            <div className="d-flex justify-content-end mt-4 mb-2">
                                                <ModalAddButtonService type={"submit"}>Edit</ModalAddButtonService>
                                            </div>
                                        </FormControl>
                                    </UsersForm>
                                </>
                                :
                                ""
                        }

                    </ModalStyleMobileResponsive>
                </>
            )
        }
    }
    else
        return null
}

export default SubSubServiceModal
